{
  "common": {
    "ok": "확인",
    "cancel": "취소",
    "yes": "예",
    "no": "아니요",
    "loading": "로딩 중...",
    "error": "오류",
    "retry": "다시 시도",
    "apply": "적용",
    "add": "추가"
  },
  "navigation": {
    "home": "홈",
    "favorites": "즐겨찾기",
    "search": "검색"
  },
  "jobs": {
    "noJobs": "직업을 찾을 수 없습니다",
    "loadMore": "더 불러오기",
    "apply": "지원하기",
    "save": "저장",
    "unsave": "제거"
  },
  "search": {
    "placeholder": "직업 검색...",
    "filter": "필터",
    "clear": "지우기",
    "open": "직업 검색",
    "close": "검색 닫기"
  },
  "alerts": {
    "title": "채용 알림",
    "subtitle": "저장한 검색과 일치하는 새 공고가 올라오면 알림을 받아요.",
    "placeholder": "키워드 (예: react 리모트 시니어)",
    "empty": "아직 알림이 없어요",
    "matchingNow": "현재 {{count}}건 일치"
  },
  "description": {
    "openUrlMessage": "더 많은 정보를 위해 URL 열기",
    "postedOn": "게시일",
    "applyViewDetails": "지원 / 세부 정보 보기"
  },
  "error": {
    "title": "문제가 발생했습니다",
    "description": "죄송합니다, 직업을 찾을 수 없습니다! 서버 또는 네트워크 오류일 수 있습니다.",
    "tryAgain": "다시 시도"
  },
  "filter": {
    "refineJobs": "직업 정제",
    "title": "필터",
    "total": "총",
    "reset": "재설정",
    "filterByDate": "날짜로 필터링",
    "byDate": "날짜별",
    "byApplied": "지원 여부별",
    "appliedOnlyOn": "지원한 것만: 켬",
    "appliedOnlyOff": "지원한 것만: 끔",
    "postedAfter": "다음 이후 게시",
    "filterByTags": "태그로 필터링",
    "byTag": "태그별",
    "clearAllFavorites": "모든 즐겨찾기 삭제",
    "applyFilters": "필터 적용"
  },
  "share": {
    "message": "여기 훌륭한 원격 직업 기회가 있습니다:\n* 직위: {{position}}\n* 회사: {{company}}\n* URL: {{url}}",
    "title": "원격 근무 앱 - {{position}} @{{company}}",
    "subject": "원격 근무 앱에서 공유된 직업",
    "dialogTitle": "원격 직업 공유"
  },
  "datepicker": {
    "selectDate": "날짜 선택",
    "year": "년",
    "month": "월",
    "previousMonth": "이전 달",
    "nextMonth": "다음 달",
    "weekdays": [
      "일",
      "월",
      "화",
      "수",
      "목",
      "금",
      "토"
    ],
    "months": [
      "1월",
      "2월",
      "3월",
      "4월",
      "5월",
      "6월",
      "7월",
      "8월",
      "9월",
      "10월",
      "11월",
      "12월"
    ]
  },
  "tabs": {
    "allJobs": "모든 직업",
    "favorites": "즐겨찾기",
    "resumeBuilder": "이력서",
    "applications": "지원 현황",
    "profile": "프로필"
  },
  "favorites": {
    "deleteAll": "모든 즐겨찾기 삭제",
    "empty": "아직 즐겨찾기가 없습니다. 공고의 하트를 눌러 여기에 저장하세요."
  },
  "icons": {
    "jobActions": "직업 액션",
    "addToFavorites": "즐겨찾기에 추가",
    "removeFromFavorites": "즐겨찾기에서 제거",
    "share": "공유",
    "openUrl": "URL 열기",
    "markApplied": "지원한 것으로 표시",
    "removeApplied": "지원 표시 제거"
  },
  "job": {
    "applied": "지원함",
    "fit": "적합도 {{score}}%"
  },
  "list": {
    "found": "건"
  },
  "onboarding": {
    "tagline": "전 세계에서 엄선된 원격 근무 기회를 발견하세요!",
    "next": "다음"
  },
  "tour": {
    "skip": "건너뛰기",
    "next": "다음",
    "getStarted": "시작하기",
    "slides": {
      "welcome": {
        "title": "환영합니다",
        "description": "주요 기능을 빠르게 둘러보고 다음 원격 일자리를 더 빨리 찾아보세요."
      },
      "search": {
        "title": "검색 및 필터",
        "description": "키워드로 검색하고 날짜, 태그, 지원 상태로 결과를 좁혀보세요."
      },
      "favorites": {
        "title": "즐겨찾기와 지원한 일자리",
        "description": "하트를 눌러 일자리를 저장하고 이미 지원한 일자리를 표시하세요."
      },
      "tracker": {
        "title": "지원 현황 관리",
        "description": "지원한 공고를 표시하고 면접, 합격 등 단계별로 메모와 날짜와 함께 추적하세요."
      },
      "alerts": {
        "title": "새 매칭 공고 알림 받기",
        "description": "검색을 저장하면 키워드에 맞는 새로운 원격 근무 공고가 올라올 때 푸시 알림을 받습니다."
      },
      "resume": {
        "title": "이력서 만들기",
        "description": "전문적인 이력서를 만들고 PDF 또는 DOCX로 내보내며, 각 공고가 내 역량과 얼마나 잘 맞는지 확인하세요."
      },
      "account": {
        "title": "로그인하여 동기화",
        "description": "무료 계정을 만들어 이력서, 지원 현황, 즐겨찾기, 알림을 모든 기기에 백업하세요."
      },
      "settings": {
        "title": "테마와 언어",
        "description": "라이트와 다크 모드를 전환하고 설정에서 9개 언어 중에서 선택하세요."
      }
    }
  },
  "theme": {
    "toggle": "테마 전환"
  },
  "settings": {
    "title": "설정",
    "theme": "테마",
    "themeLight": "라이트",
    "themeDark": "다크",
    "language": "언어",
    "open": "설정 열기",
    "close": "닫기",
    "developer": "개발자",
    "hideAds": "광고 숨기기",
    "removeAds": {
      "title": "광고 제거",
      "buy": "광고 제거 — {{price}}",
      "restore": "구매 복원",
      "purchased": "RemoteWork를 지원해 주셔서 감사합니다! 광고가 비활성화되었습니다.",
      "successTitle": "광고 제거 완료",
      "successMessage": "지원해 주셔서 감사합니다! 이제 앱 전체에서 광고가 표시되지 않습니다.",
      "errorTitle": "구매 실패",
      "errorMessage": "문제가 발생했습니다. 다시 시도해 주세요.",
      "restoreEmptyTitle": "복원할 항목 없음",
      "restoreEmptyMessage": "이 계정에서 이전 구매 내역을 찾을 수 없습니다."
    },
    "tour": "투어",
    "replayTour": "투어 다시 보기",
    "account": "계정",
    "deleteAccount": {
      "action": "계정 삭제",
      "confirmTitle": "계정을 삭제할까요?",
      "confirmMessage": "계정과 동기화된 모든 데이터(이력서, 지원 현황, 즐겨찾기, 알림)가 영구적으로 삭제됩니다. 되돌릴 수 없습니다.",
      "errorTitle": "계정을 삭제할 수 없습니다",
      "errorMessage": "문제가 발생했습니다. 다시 시도해 주세요.",
      "reauthMessage": "보안을 위해 로그아웃 후 다시 로그인한 다음 계정 삭제를 다시 시도해 주세요."
    },
    "about": "정보",
    "privacyPolicy": "개인정보 처리방침",
    "website": "웹사이트 방문"
  },
  "ad": {
    "sponsored": "광고"
  },
  "consent": {
    "message": "사이트 사용 방식을 이해하기 위해 분석 쿠키를 사용합니다. 동의하실 때까지 비활성화 상태로 유지됩니다.",
    "accept": "동의",
    "reject": "거부"
  },
  "disclaimer": {
    "title": "채용 공고 안내",
    "message": "이 앱에 표시되는 채용 공고는 제3자 출처와 공개 API에서 가져온 것입니다. 당사는 이러한 공고를 게시하거나 선별하거나 관리하지 않으며, 어떤 공고의 정확성, 품질 또는 유효성도 보장할 수 없습니다. 지원하기 전에 항상 고용주에게 직접 세부 정보를 확인하세요.",
    "okCountdown": "확인 ({{seconds}})"
  },
  "resume": {
    "title": "이력서 빌더",
    "newResume": "새로 만들기",
    "newResumePrompt": "이력서 이름을 입력하세요",
    "namePlaceholder": "예: 프론트엔드 이력서",
    "lastModified": "마지막 수정",
    "discardTitle": "변경 사항을 취소할까요?",
    "discardMessage": "저장하지 않은 변경 사항이 있습니다.",
    "webPlaceholder": {
      "title": "이력서 빌더는 모바일에서만 사용할 수 있습니다",
      "subtitle": "Android 또는 iOS 앱에서 열어 이력서를 만들고 내보내세요."
    },
    "actions": {
      "edit": "편집",
      "duplicate": "복제",
      "delete": "삭제",
      "more": "추가 옵션",
      "deleteConfirmTitle": "이력서를 삭제할까요?",
      "deleteConfirmMessage": "\"{{name}}\"을(를) 영구적으로 삭제하시겠어요? 되돌릴 수 없습니다."
    },
    "empty": {
      "title": "아직 이력서가 없습니다",
      "subtitle": "전문적인 이력서를 만들고 PDF 또는 DOCX로 내보내세요.",
      "cta": "첫 이력서 만들기",
      "skillsHint": "JavaScript, 디자인, 리더십과 같은 기술을 추가하세요…"
    },
    "sections": {
      "personalInfo": "개인 정보",
      "experience": "경력",
      "education": "학력",
      "skills": "기술",
      "languages": "언어",
      "links": "링크",
      "template": "템플릿",
      "contact": "연락처",
      "summary": "요약",
      "personalization": "개인화",
      "preview": "미리보기"
    },
    "fields": {
      "fullName": "이름",
      "title": "직함",
      "email": "이메일",
      "phone": "전화",
      "location": "위치",
      "website": "웹사이트",
      "summary": "자기 소개",
      "company": "회사",
      "position": "직책",
      "institution": "학교",
      "degree": "학위",
      "field": "전공",
      "startDate": "시작일",
      "endDate": "종료일",
      "current": "현재 근무 중",
      "present": "현재",
      "description": "설명",
      "skillPlaceholder": "기술 추가",
      "languageName": "언어",
      "languageProficiency": "수준",
      "linkLabel": "레이블",
      "linkUrl": "URL",
      "phoneCountryCode": "국가 번호"
    },
    "proficiency": {
      "basic": "기초",
      "conversational": "회화 가능",
      "fluent": "유창함",
      "native": "원어민"
    },
    "templates": {
      "modern": "모던",
      "classic": "클래식",
      "minimal": "미니멀",
      "modernDescription": "컬러 사이드바가 있는 2단 레이아웃입니다.",
      "classicDescription": "전통적인 흑백 단일 컬럼 디자인입니다.",
      "minimalDescription": "여백이 많고 색상이 없는 깔끔한 디자인입니다."
    },
    "buttons": {
      "addExperience": "경력 추가",
      "addEducation": "학력 추가",
      "addLanguage": "언어 추가",
      "addLink": "링크 추가",
      "remove": "삭제",
      "save": "저장",
      "discard": "버리기",
      "export": "내보내기",
      "exportPdf": "PDF로 내보내기",
      "exportDocx": "DOCX로 내보내기",
      "create": "만들기",
      "previous": "이전",
      "next": "다음"
    },
    "export": {
      "preparing": "파일을 준비 중입니다…",
      "preparingHint": "형식을 선택하세요. 준비가 되면 공유 시트에서 열립니다.",
      "errorTitle": "내보내기 실패",
      "errorMessage": "이력서를 내보내는 중 문제가 발생했습니다."
    },
    "validation": {
      "invalidEmail": "유효한 이메일 주소를 입력하세요.",
      "invalidCountryCode": "+로 시작 가능한 최대 4자리 숫자를 입력하세요.",
      "invalidWebsite": "유효한 웹사이트 주소를 입력하세요 (예: example.com)."
    },
    "personalization": {
      "title": "개인화",
      "colorMode": "색상 테마",
      "modes": {
        "light": "라이트",
        "dark": "다크"
      },
      "fontFamily": "글꼴",
      "fonts": {
        "sans": "산세리프",
        "serif": "세리프",
        "modern": "모던",
        "mono": "고정폭"
      },
      "fontSize": "글꼴 크기",
      "sizes": {
        "title": "제목",
        "subtitle": "부제목",
        "body": "본문"
      },
      "increase": "{{field}} 늘리기",
      "decrease": "{{field}} 줄이기"
    },
    "photo": {
      "placeholder": "사진 없음",
      "choose": "사진 추가",
      "change": "사진 변경",
      "remove": "삭제",
      "permissionTitle": "권한 필요",
      "permissionMessage": "프로필 사진을 선택하려면 사진 라이브러리 접근을 허용하세요."
    }
  },
  "sort": {
    "recent": "최신순",
    "bestFit": "적합도순",
    "toggle": "적합도순으로 정렬"
  },
  "applyKit": {
    "title": "지원 키트",
    "hint": "탭하여 복사한 뒤 지원서 양식에 붙여넣으세요.",
    "copied": "복사됨",
    "openExternal": "브라우저에서 열기"
  },
  "applications": {
    "title": "지원 현황",
    "empty": {
      "title": "아직 지원 내역이 없어요",
      "subtitle": "지원한 공고가 여기에 표시되어 상태를 추적할 수 있어요."
    },
    "status": {
      "applied": "지원함",
      "interviewing": "면접",
      "offer": "오퍼",
      "rejected": "불합격"
    },
    "notesPlaceholder": "메모 추가…",
    "remove": "삭제",
    "removeConfirm": "이 지원 내역을 삭제할까요?",
    "lastUpdate": "마지막 업데이트: {{date}}",
    "editDate": "날짜 편집",
    "addManual": "지원 추가"
  },
  "auth": {
    "account": "계정",
    "signIn": "로그인",
    "signUp": "계정 만들기",
    "signOut": "로그아웃",
    "title": {
      "signIn": "다시 오신 걸 환영해요",
      "signUp": "계정을 만드세요"
    },
    "email": "이메일",
    "password": "비밀번호",
    "showPassword": "비밀번호 표시",
    "hidePassword": "비밀번호 숨기기",
    "forgotPassword": "비밀번호를 잊으셨나요?",
    "resetSent": "비밀번호 재설정 이메일을 보냈어요 — 받은편지함을 확인하세요.",
    "enterEmailFirst": "먼저 이메일을 입력하세요.",
    "noAccount": "계정이 없으신가요? 만들기",
    "haveAccount": "이미 계정이 있으신가요? 로그인",
    "criteria": {
      "minLength": "8자 이상",
      "uppercase": "대문자 1개",
      "lowercase": "소문자 1개",
      "numeric": "숫자 1개",
      "special": "특수문자 1개"
    },
    "errors": {
      "invalid-email": "이메일 주소가 올바르지 않은 것 같아요.",
      "invalid-credential": "이메일 또는 비밀번호가 올바르지 않아요.",
      "user-not-found": "해당 이메일의 계정을 찾을 수 없어요.",
      "wrong-password": "이메일 또는 비밀번호가 올바르지 않아요.",
      "email-already-in-use": "이미 해당 이메일로 가입된 계정이 있어요.",
      "weak-password": "비밀번호가 요구 사항을 충족하지 않아요.",
      "requires-recent-login": "계속하려면 다시 로그인해 주세요.",
      "too-many-requests": "시도가 너무 많아요. 나중에 다시 시도하세요.",
      "network": "네트워크 오류예요. 연결을 확인하세요.",
      "not-configured": "지금은 로그인을 사용할 수 없어요.",
      "unknown": "문제가 발생했어요. 다시 시도해 주세요."
    },
    "continueGoogle": "Google로 계속하기",
    "continueApple": "Apple로 계속하기",
    "or": "또는",
    "loggedInAnonymous": "익명으로 로그인됨",
    "continueAnonymous": "익명으로 계속하기",
    "loggedOutWarning": "로그인하지 않았어요 — 데이터가 이 기기에만 저장되어 사라질 수 있어요."
  },
  "profile": {
    "title": "프로필",
    "signInRegister": "로그인 / 회원가입",
    "more": "더 보기"
  },
  "applyBrowser": {
    "title": "지원하기"
  }
}
